module.exports = __webpack_public_path__ + "img/img-scholarship@1x.5a04f01a.jpg";